export const OPTION_TYPE_VALUE = 'other';
